import { AddressOrdersFormValues, PatientAddress } from '../../models';

export class FetchOrdersAndReorders {
  static readonly type = '[Orders] Fetch Orders and Reorders';
}

export class SetOrderAddresses {
  static readonly type = '[Orders] Set Order Addresses';
  constructor(public formValues: AddressOrdersFormValues, public newAddress: PatientAddress) {}
}
